"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useApplyManualFormErrorsEffect = exports.applyManualErrors = void 0;

var _ramda = require("ramda");

var _react = require("react");

/**
 * Apply errors manually to the form, it may be useful when you need apply errors from  Back-end response.
 *
 * Example:
 *
 * type TFormValues = {
 *   field: string;
 *   parentField: {
 *     childField: string;
 *   }
 * }
 *
 *
 * // For declared TFormValues the errors should be like:
 * const errors = {
 *   field: 'no no no',
 *   'parentField.childField': ['wow wow wow'],
 * }
 *
 * // Also, the type of errors should be like
 * import { Path } from 'react-hook-form';
 *
 * type TFormValuesErrors = Partial<Record<Path<TFormValues>, string | string[]>>
 * // which equals to:
 * // TPlainErrors<TFormValues>
 */
var applyManualErrors = function applyManualErrors(setError, errors) {
  (0, _ramda.forEachObjIndexed)(function (error, field) {
    var message = Array.isArray(error) ? error[0] : error;

    if (typeof message === 'string' && message.length) {
      setError(field, {
        type: 'manual',
        message: message
      });
    }
  }, errors);
};

exports.applyManualErrors = applyManualErrors;

var useApplyManualFormErrorsEffect = function useApplyManualFormErrorsEffect(setError, errors) {
  (0, _react.useEffect)(function () {
    if (errors) {
      applyManualErrors(setError, errors);
    }
  }, [setError, errors]);
};

exports.useApplyManualFormErrorsEffect = useApplyManualFormErrorsEffect;